let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5506N")).then(() => parcelRequire('33OOq'));